module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "نبذة-عن-الكتاب-على-الغلاف-الخلفي"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نبذة عن الكتاب على الغلاف الخلفي")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فابريس "), _c('em', [_vm._v("چومون")]), _vm._v(" الملقب بـ \"عرّاب برامج الدمج اللغوي\" من قِبل صحيفة نيويورك تايمز في عام 2014، وهو الملحق"), _c('em', [_vm._v(" التعليمي والثقافي لسفارة فرنسا في الولايات المتحدة،")]), _vm._v(" لديه أكثر من 25 عاماً من الخبرة في مجال التعليم الدولي وتطوير البرامج متعددة اللغات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حصل چومون على درجة الدكتوراه في التعليم الدولي من جامعة نيويورك (")]), _vm._v("NYU"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(") كما حصل على عدة جوائز وأوسمة مثل \"وسام النخلة\" الأكاديمي، وهو وسام استحقاق من الحكومة الفرنسية، وجائزة التنوع الثقافي من المنظمة الدولية للفرانكفونية لدى الأمم المتحدة، ووسام الاعتراف من مؤسسة")]), _vm._v(" CAF USA"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وضع "), _c('em', [_vm._v("چومون")]), _vm._v(" خبرته مباشرة في خدمة المجتمعات الفرنسية والإيطالية واليابانية والألمانية والروسية")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الولايات المتحدة؛ من خلال مساعدتهم على تطوير برامج ثنائية اللغة ذات جودة عالية في المدارس الحكومية المحلية.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22c3d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0